import { ACCESSIBILITY_OPTIONS, eventPropKeys } from "./Constants";
import { isValidMapUrl, countUniqueValues, checkUniqueValues } from "./Utils";

export const mutateEventPropsData = (event) => {
  const checkIfNullAdditionalInfo = (e) => {
    if (!e.length) return false;

    const {
      duration,
      intermission,
      accessInfo,
      hasSeats,
      hasParking,
      venueMapUrl,
    } = e[0];

    return [
      duration === 0 || duration === null,
      intermission === 0 || intermission === null,
      accessInfo === "" || accessInfo === null,
      hasSeats === null,
      hasParking === null,
      venueMapUrl === "" || venueMapUrl === null || venueMapUrl === undefined,
    ].every(Boolean);
  };

  const hasSameInfoData = checkUniqueValues(event, eventPropKeys);
  const producerCount = countUniqueValues(event, "producerId");
  const nullAdditionalInfo = checkIfNullAdditionalInfo(event);
  const multipleCancellationPolicies =
    countUniqueValues(event, "allowCancel") > 1 ||
    countUniqueValues(event, "allowUpdate") > 1;

  const allowCancelProp =
    countUniqueValues(event, "allowCancel") === 1 ? event[0].allowCancel : null;

  const allowUpdateProp =
    countUniqueValues(event, "allowUpdate") === 1 ? event[0].allowUpdate : null;

  const producerNameProp = producerCount === 1 ? event[0].producerName : null;

  const hasCancellationPolicySection =
    nullAdditionalInfo || !hasSameInfoData || multipleCancellationPolicies;

  const hasAdditionalInfoSection = !nullAdditionalInfo && hasSameInfoData;

  const noOfEvents = event.length;

  const venueSeatsProp =
    noOfEvents === 1
      ? {
          hasUnnumberedSections: event[0]?.hasUnnumberedSections,
          hasNumberedSeats: event[0]?.hasNumberedSeats,
          hasTwoLevelFoolrplan: event[0]?.hasTwoLevelFoolrplan,
              soldOut: event[0]?.soldOut        
        }
      : null;

  //TODO:
  // const venueSeatsProp =
  // noOfEvents === 1 &&
  //   !event[0]?.hasNumberedSeats &&
  //   !event[0]?.hasTwoLevelFoolrplan &&
  //   event[0]?.hasUnnumberedSections &&
  //   !event[0]?.soldOut;
  //and just check if it is true

  return {
    events: [...event],
    hasSameInfoData,
    nullAdditionalInfo,
    multipleCancellationPolicies,
    allowCancelProp,
    allowUpdateProp,
    producerNameProp,
    hasAdditionalInfoSection,
    hasCancellationPolicySection,
    noOfEvents,
    producerCount,
    venueSeatsProp,
    additionalInfoData:
      noOfEvents >= 1 ? mutateAdditionalInfoData(event[0]) : null,
  };
};

export const mutateAdditionalInfoData = (event) => {
  const accessibilityEnabledOptions = Object.values(ACCESSIBILITY_OPTIONS)
    .filter((option) => event?.accessibility & option.bit)
    .map((result) => result.text);

  const hasMapSection =
    event?.venueMapUrl &&
    !event.isStreaming &&
    isValidMapUrl(event.venueMapUrl);

  const hasAccessInfoSection = event.accessInfo && !event.isStreaming;

  const hasSeatsParkingSection =
    (event.hasSeats !== null || event.hasParking !== null) &&
    !event.isStreaming;

  const hasAccessibilitySection =
    event.accessibility > 0 && event.accessibility && !event.isStreaming;

  const hasDurationIntermission =
    (event.duration > 0 && event.duration) ||
    (event.intermission > 0 && event.intermission);

  const hasCancellationPolicySection = event.eventId !== 686112; //custom catch for specific event.

  const durationIntermissionData = [
    //data to shown if duration-intermission section is available
    {
      title: playdetailsv2_resources.UIDurationLabelText,
      icon: "/Site/images/icons/EventPage/playduration.svg",
      value: event.duration,
    },
    {
      title: playdetailsv2_resources.WithBreak,
      icon: "/Site/images/icons/EventPage/intermission.svg",
      value: event.intermission,
    },
  ];

  const seatsParkingData = [
    // data to shown if seats-parking section is available
    {
      title: playdetailsv2_resources.Seating,
      icon: "/Site/images/icons/EventPage/seating.svg",
      available: !!event.hasSeats,
    },
    {
      title: playdetailsv2_resources.UIHasParkingLabelText,
      icon: "/Site/images/icons/EventPage/parking.svg",
      available: !!event.hasParking,
    },
  ];

  return {
    ...event,
    accessibilityEnabledOptions,
    hasMapSection,
    hasAccessInfoSection,
    hasSeatsParkingSection,
    hasAccessibilitySection,
    hasDurationIntermission,
    hasCancellationPolicySection,
    durationIntermissionData,
    seatsParkingData,
  };
};
